import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

import Loader from 'components/Loader'

const GestionProductosTienda = lazy(async () => import('./Productos'))
const GestionMovimientosTienda = lazy(async () => import('./Movimientos'))
const GestionOrdenCompraTienda = lazy(async () => import('./OrdenDeCompra/OrdendeCompra'))
const GestionKardex = lazy(async () => import('./Kardex'))

const Tienda = ({ match }: any) => {

    return (
        <div className="app-wrapper">
            <Switch>
                <Suspense fallback={<Loader />}>
                    <Route path={`${match.url}/productos`} component={GestionProductosTienda} />
                    <Route path={`${match.url}/movimientos`} component={GestionMovimientosTienda} />
                    <Route path={`${match.url}/orden-compra`} component={GestionOrdenCompraTienda} />
                    <Route path={`${match.url}/kardex`} component={GestionKardex} />
                </Suspense>
            </Switch>
        </div>
    )
}

export default Tienda
